<template>
    <div ref="navWrap" class="xc-tabs" :style="{padding:scrollable?'0 34px':'0'}">
        <span v-if="type=='card'" :class="['xc-nav-prev', scrollable ? '' : 'xc-nav-scroll-disabled']" @click="scrollPrev"><Icon type="ios-arrow-back" style="vertical-align: -1px;"></Icon></span>
        <span v-if="type=='card'" :class="['xc-nav-next', scrollable ? '' : 'xc-nav-scroll-disabled']" @click="scrollNext"><Icon type="ios-arrow-forward" style="vertical-align: -1px;"></Icon></span>
        <span v-if="type=='line'" :class="['xc-nav-prev', scrollable ? '' : 'xc-nav-scroll-disabled','xc-nav-line','xc-nav-line-prev']" @click="scrollPrev"><xc-icon iconClass="home_left" style="width:16px;height:16px;fill:#9EA7B4"></xc-icon></span>
        <span v-if="type=='line'" :class="['xc-nav-next', scrollable ? '' : 'xc-nav-scroll-disabled','xc-nav-line','xc-nav-line-next']" @click="scrollNext"><xc-icon iconClass="home_right" style="width:16px;height:16px;fill:#9EA7B4"></xc-icon></span>
        <div ref="navScroll" :class="['xc-tabs-'+type,'xc-tab-nav-scroll']" :style="{width:scrollWidth}">
            <div ref="nav" class="xc-tabs-nav" :style="navStyle">
                <div
                    v-if="type=='card'"
                    v-for="(item,index) in tabList"
                    :key="index"
                    :style="{padding:paddingItem}"
                    :class="[tabIndex == item.index ? 'tabs-card-active' : '','tabs-item',tabList.length<=1?'tabs-border':'']"
                    @click="changeTab(item)">
                        <span v-if="item.status" :class="['tabs-dot-'+item.status,'tabs-dot']"></span>
                        <!-- <span class="review-num" v-if="item.num">{{item.num}}</span> -->
                        {{item.name}}<span v-if="item.num" style="margin-left:2px">({{item.num}})</span>
                </div>
                <div v-if="type=='line'">
                    <div
                        @click="changeTab(item)"
                        :class="[tabIndex == item.index ?'tabs-line-active':'','tabs-line-item']"
                        v-for="(item,index) in tabList">{{item.name}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import elementResizeDetectorMaker from 'element-resize-detector';

export default {
    name:'xc-tabs',
    provide () {
        return { TabsInstance: this };
    },
    props:{
        tabList:{
            type:Array,
            default:()=>{return []}
        },
        tabIndex:{
            type:Number,
            default:0
        },
        /**
         * tab切换类型 默认card
         */
        type:{
            type:String,
            default:'card'
        },
        scrollWidth:{
            type:String,
            default:'auto'
        },
        paddingItem:{
            type:String,
            default:'0px 24px'
        }
    },
    data(){
        return{
            navStyle: {
                transform: ''
            },
            scrollable:false
        }
    },
    watch:{
        tabList:{
            handler(newVal){
                this.$nextTick(()=>{
                    this.updateNavScroll()
                })
            },
            deep:true
        },
        tabIndex(newVal){
            this.$nextTick(()=>{
                this.scrollToActiveTab()
            })
        }
    },
    mounted(){
        this.observer = elementResizeDetectorMaker();
        this.observer.listenTo(this.$refs.navWrap, this.handleResize);

        const hiddenParentNode = this.isInsideHiddenElement();
        if (hiddenParentNode) {
            this.mutationObserver = new MutationObserver(() => {
                if (hiddenParentNode.style.display !== 'none') {
                    this.updateBar();
                    this.mutationObserver.disconnect();
                }
            });

            this.mutationObserver.observe(hiddenParentNode, { attributes: true, childList: true, characterData: true, attributeFilter: ['style'] });
        }
    },
    beforeDestroy() {
        this.observer.removeListener(this.$refs.navWrap, this.handleResize);
        if (this.mutationObserver) this.mutationObserver.disconnect();
    },
    methods:{
        /**
         * tab事件派发
         *
         * @param {Object} tab
         */
        changeTab: function (tab) {
            this.$emit('changeTab', tab)
        },
        handleResize(){
            this.updateNavScroll();
        },
        scrollToActiveTab() {
            if (!this.scrollable) return;
            const nav = this.$refs.nav;
            const activeTab = this.$el.querySelector(`.tabs-${this.type}-active`);
            if(!activeTab) return;

            const navScroll = this.$refs.navScroll;
            const activeTabBounding = activeTab.getBoundingClientRect();
            const navScrollBounding = navScroll.getBoundingClientRect();
            const navBounding = nav.getBoundingClientRect();
            const currentOffset = this.getCurrentScrollOffset();
            let newOffset = currentOffset;

            if (navBounding.right < navScrollBounding.right) {
                newOffset = nav.offsetWidth - navScrollBounding.width;
            }

            if (activeTabBounding.left < navScrollBounding.left) {
                newOffset = currentOffset - (navScrollBounding.left - activeTabBounding.left);
            }else if (activeTabBounding.right > navScrollBounding.right) {
                newOffset = currentOffset + activeTabBounding.right - navScrollBounding.right;
            }
            console.log(newOffset,'newOffset')
            if(currentOffset !== newOffset){
                this.setOffset(Math.max(newOffset, 0));
            }
        },
        updateNavScroll(){
            const navWidth = this.$refs.nav.offsetWidth;
            const containerWidth = this.$refs.navScroll.offsetWidth;
            const currentOffset = this.getCurrentScrollOffset();
            if (containerWidth < navWidth) {
                this.scrollable = true;
                if (navWidth - currentOffset < containerWidth) {
                    this.setOffset(navWidth - containerWidth);
                }
            } else {
                this.scrollable = false;
                if (currentOffset > 0) {
                    this.setOffset(0);
                }
            }
        },
        setOffset(value) {
            this.navStyle.transform = `translateX(-${value}px)`;
        },
        getCurrentScrollOffset() {
            const { navStyle } = this;
            return navStyle.transform
                ? Number(navStyle.transform.match(/translateX\(-(\d+(\.\d+)*)px\)/)[1])
                : 0;
        },
        scrollPrev() {
            const containerWidth = this.$refs.navScroll.offsetWidth;
            const currentOffset = this.getCurrentScrollOffset();
            if (!currentOffset) return;

            let newOffset = currentOffset > containerWidth
                ? currentOffset - containerWidth
                : 0;

            this.setOffset(newOffset);
        },
        scrollNext() {
            const navWidth = this.$refs.nav.offsetWidth;
            const containerWidth = this.$refs.navScroll.offsetWidth;
            const currentOffset = this.getCurrentScrollOffset();
            if (navWidth - currentOffset <= containerWidth) return;

            let newOffset = navWidth - currentOffset > containerWidth * 2
                ? currentOffset + containerWidth
                : (navWidth - containerWidth);

            this.setOffset(newOffset);
        },
        isInsideHiddenElement () {
            let parentNode = this.$el.parentNode;
            while(parentNode && parentNode !== document.body) {
                if (parentNode.style && parentNode.style.display === 'none') {
                    return parentNode;
                }
                parentNode = parentNode.parentNode;
            }
            return false;
        },
        updateBar () {
            this.$nextTick(() => {
                
                this.updateNavScroll();
            });
        },
    }
}
</script>

<style lang="less" scoped>
.xc-tab-nav-scroll{
    overflow: hidden;
    white-space: nowrap;

    .xc-tabs-nav{
        padding-left: 0;
        margin: 0;
        float: left;
        list-style: none;
        box-sizing: border-box;
        position: relative;
        transition: -webkit-transform .5s ease-in-out;
        transition: transform .5s ease-in-out;
        transition: transform .5s ease-in-out,-webkit-transform .5s ease-in-out;
    }
}
.xc-tabs{
    position: relative;
    padding: 0 34px;

    .xc-nav-next, .xc-nav-prev{
        position: absolute;
        height: 32px;
        line-height: 32px;
        padding: 0 10px;
        cursor: pointer;
        border: 1px solid #D7DDE4;
        border-radius: 3px;
        background: #fff;
        z-index: 1;
    }
    .xc-nav-prev{
        left: 0;
        border-radius: 3px 0px 0px 3px;
    }
    .xc-nav-next{
        right: 0;
        border-radius: 0px 3px 3px 0px;
    }
    .xc-nav-scroll-disabled{
        display: none;
    }
    .xc-tabs-card{
        display: inline-block;
        font-size: 0;
        border-radius: 3px;
        height: 32px;
        line-height: 32px;
        box-sizing: border-box;
        .tabs-item{
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0px 24px;
            font-size: 14px;
            font-weight: normal;
            color: #464C5B;
            border-left: 1px solid #D7DDE4;
            border-top:1px solid #D7DDE4;
            border-bottom:1px solid #D7DDE4;
            cursor: pointer;
            &:hover{
                color: #4B8CF0;
            }
            &:last-child{
                border-radius:0px 3px 3px 0px;
                border-right:1px solid #D7DDE4;

            }
            &:first-child{
                border-radius:3px 0px 0px 3px;
                border-left:1px solid #D7DDE4;
            }
            .tabs-dot{
                display: inline-block;
                width: 8px;
                height: 8px;
                border-radius: 50%;
            }
            .tabs-dot-1{
                background-color: #1F6CDD;
            }
            .tabs-dot-2{
                background-color: #9EA7B4;
            }
            .tabs-dot-3{
                background-color: #FF9900;
            }
            .review-num{
                // position: absolute;
                // top:6px;
                // right: -25px;
                background: #FF3300;
                text-align: center;
                min-width: 18px;
                height: 18px;
                line-height: 18px;
                font-size: 12px;
                color: #fff !important;
                border-radius: 16px;
                float: right;
                // margin-right: 28px;
                margin-left: 4px;
                margin-top: 7px;
                font-family: Arial, Helvetica, sans-serif;
                box-shadow: 0 0 4px 0px #FF3300;
            }

        }
        .tabs-border{
            border-radius: 3px !important;
        }
        .tabs-card-active{
            color: #fff;
            background-color: #1f6cdd;
            border-top:1px solid #1f6cdd;
            border-bottom: 1px solid #1f6cdd;
            border-right: 1px solid #1f6cdd;
            border-left: 1px solid #1f6cdd !important;
            &:hover{
                color:#fff;
            }
            &:last-child{
                border-right:0;
            }
            &+div{
                border-left: none;
            }
        }
    }
    .xc-tabs-line{
        margin: 0 8px;
        .tabs-line-item{
            display: inline-block;
            line-height: 1;
            padding: 24px 16px 12px 16px;
            font-size: 16px;
            color: #9EA7B4;
            cursor: pointer;
        }
        .tabs-line-active{
            position: relative;
            // border-width: 24px;
            // border-bottom:3px solid #1F6CDD;
            color: #1F6CDD;

            &::before{
                content: '';
                width: 24px;
                height: 4px;
                position: absolute;
                left: 50%;
                margin-left: -12px;
                bottom: 0;
                background: #1F6CDD;
            }
        }
    }

    .xc-nav-line{
        border: none;
        padding: 0 5px;
        bottom: 0;

    }
    .xc-nav-line-prev{
        left: 20px;
    }
    .xc-nav-line-next{
        right: 20px;
    }
}
</style>
